<div>

  <div class="border  border-grey-900 rounded-lg p-4" [ngClass]="{'my-2':!editMode,'my-3':editMode}">
    <div class="flex flex-col justify-between w-full">
      @if (!editMode) {
        <div class="flex flex-col justify-between w-full md:flex-row ">
          <div class="flex flex-col  items-baseline pr-5 flex-grow">
            <h4 class="text-base text-green-700">{{question.QuestionHeader}}</h4>
            <p class="mt-1 text-sm"><span class="text-sm text-grey-900">Type:
            </span>{{question.QuestionType.Description}}</p>
          </div>
          <div class="flex justify-between items-center md:mt-0  mt-3 ">
            <div class="flex flex-col md:flex-row text-sm group cursor-pointer mr-2" (click)="toggleEditMode()">
              <span
              class=" material-symbols-outlined text-2xl group-hover:text-green-400 items-center md:mr-1">edit</span><span
            class="text-sm text-green-300 ">edit</span>
          </div>
          <div class="flex flex-col md:flex-row text-sm group cursor-pointer mr-2" (click)="dupQuestion()">
            <span
            class=" material-symbols-outlined text-2xl group-hover:text-grey-900 items-center md:mr-1">file_copy</span><span
          class="text-sm text-grey-900 ">copy</span>
        </div>
        <div class="flex flex-col md:flex-row text-sm group cursor-pointer" (click)="toggleDelete()"><span
        class=" material-symbols-outlined text-2xl  group-hover:text-danger-base items-center md:mr-1">delete</span><span
      class="text-sm text-danger-base">delete</span></div>
    </div>
    <div class="flex md:justify-center justify-end items-center md:ml-5 md:mt-0 mt-5">
      <span cdkDragHandle class="material-symbols-outlined"
      [ngClass]="{'cursor-move':!groupEditOn,'cursor-not-allowed text-grey-500':groupEditOn}">drag_indicator</span>
    </div>
  </div>
}
@if (deleteMode && !editMode) {
  <div class="my-6 p-3 border-grey-300 border-2 rounded-md mx-4">
    <h4 class="mb-2">Confirm Question Removal</h4>
    <p>Once removed and saved, the question will be removed from the audit.
    </p>
    <div class="flex my-5">
      <button class="btn-primary btn-negative mr-2" (click)="delQuestion()">Confirm Removal</button>
      <button class="btn-inverse" (click)="toggleDelete()">Cancel</button>
    </div>
  </div>
}
@if (editMode) {
  <div class="md:mx-4 mx-2 ">
    <h1 class="text-center">{{question.QuestionHeader}}</h1>
    <div class="flex justify-center mb-4">
      <div class="flex md:flex-row flex-col  my-4">
        <div class="w-32 border p-1 md:p-2 rounded-tl-md  rounded-tr-md md:rounded-bl-md cursor-pointer text-center"
          [ngClass]="{'border-green-300': showCoreInfo, 'border-grey-900': !showCoreInfo, 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': showCoreInfo,'rounded-md':isHeader,' md:rounded-tr-none':!isHeader}"
          (click)="switchToCoreInfo()">
          <div class="flex flex-col">
            <span class="" [ngClass]="{'text-green-700':showCoreInfo}"
            class="material-symbols-outlined">assignment</span>
            <span class="mt-1 text-sm" [ngClass]="{'text-green-700':showCoreInfo}">Details</span>
          </div>
        </div>
        @if (isSelections||isBasic) {
          <div
            class="w-32 border border-grey-900 p-2 cursor-pointer text-center"
            [ngClass]="{'border-green-300': showSettings, 'border-grey-900': !showSettings, 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': showSettings,'rounded-tr-none md:rounded-tr-md  rounded-bl-md md:rounded-bl-none rounded-br-md':!isSelections}"
            (click)="switchToSettings()">
            <div class="flex flex-col">
              <span class="" [ngClass]="{'text-green-700':showSettings}"
              class="material-symbols-outlined">tune</span>
              <span class="mt-1 text-sm" [ngClass]="{'text-green-700':showSettings}">Settings</span>
            </div>
          </div>
        }
        @if (isSelections) {
          <div
            class="w-32 border border-grey-900 p-2 md:rounded-tr-md md:rounded-bl-none rounded-bl-md rounded-br-md cursor-pointer text-center"
            [ngClass]="{'border-green-300': showScoring, 'border-grey-900': !showScoring, 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': showScoring}"
            (click)="switchToScoring()">
            <div class="flex flex-col"><span class="" [ngClass]="{'text-green-700':showScoring}"
            class="material-symbols-outlined">rule</span>
            <span class="mt-1 text-sm" [ngClass]="{'text-green-700':showScoring}">Answers</span>
          </div>
        </div>
      }
    </div>
  </div>
  @if (showCoreInfo) {
    <div>
      <div class="">
        <p class="text-sm text-green-400">Question Header*</p>
        <input type="text" class="text-box md:w-3/5" [(ngModel)]="question.QuestionHeader"
          (ngModelChange)="questionChanged()" />
          @if (false) {
            <p class="text-danger-base text-sm mx-1">Please enter a question header.</p>
          }
        </div>
        <div class="mt-2">
          <p class="text-sm text-green-400">Question Body</p>
          <input type="text" class="text-box md:w-3/5" [(ngModel)]="question.QuestionBody"
            (ngModelChange)="questionChanged()" />
          </div>
          <div class="mt-2">
            <p class="text-sm text-green-400">Question Type*</p>
            <select class="text-box md:w-3/5" [(ngModel)]="question.QuestionType"
              [compareWith]="compareQuestionTypes" (change)="setPageMode()" (ngModelChange)="questionChanged()">
              @for (type of answerTypes; track type) {
                <option [ngValue]="type">{{type.Description}}</option>
              }
            </select>
            @if (typeWarning) {
              <div
                class="my-2 border-warning-base border-2 rounded-lg p-2 md:p-3 flex justify-start items-center  md:w-3/5">
                <span class="material-symbols-outlined text-4xl text-warning-strong">
                  exclamation
                </span>
                <p class="text-sm">Changing the audit type may invalidate existing answers. To avoid issues,
                replace incompatible questions.</p>
              </div>
            }
          </div>
          <div class="mt-2">
            <p class="text-sm text-green-400">Help Text</p>
            <textarea [(ngModel)]="question.HelpText" (ngModelChange)="questionChanged()"
            class="md:w-3/5 text-box" rows="6"></textarea>
            <p class="text-xs text-grey-700 mt-1 mb-2">Use blank lines for paragraphs and start list items with -, * or •.</p>
            <app-help-guidance [text]="question.HelpText" buttonLabel="Preview guidance"></app-help-guidance>
          </div>
          <div class="mt-2">
            <p class="text-sm text-green-400">Question Number</p>
            <input type="text" class="text-box md:w-3/5" [(ngModel)]="question.QuestionNumber"
              (ngModelChange)="questionChanged()" />
            </div>
            <p class="italic mt-1 ml-1 text-sm text-grey-900">*Required fields</p>
          </div>
        }
        @if (showSettings) {
          <div>
            <div class="flex mb-3 items-center  md:justify-start justify-between">
              <div class="md:w-1/3">
                <p class=" text-green-400">Question Required</p>
                <p class="text-sm text-grey-900 italic">Required questions must be answered</p>
              </div>
              <app-toggle-switch class="mt-1 ml-4" [(checked)]="question.Required"
              (checkedChange)="requiredQuestionChange()"></app-toggle-switch>
            </div>
            @if (requiredWarning) {
              <div
                class="my-2 border-warning-base border-2 rounded-lg p-2 md:p-3 flex justify-start items-center  md:w-1/3">
                <span class="material-symbols-outlined text-4xl text-warning-strong">
                  exclamation
                </span>
                <p class="text-sm">Making this question required may prevent in-progress audits from being submitted if users cannot access it.</p>
              </div>
            }
            <div class="flex mb-3 items-center md:justify-start justify-between">
              <div class="md:w-1/3">
                <p class=" text-green-400">Photo Required</p>
                <p class="text-sm text-grey-900 italic">Must attach a photo to answer</p>
              </div>
              <app-toggle-switch class="mt-1 ml-4" [(checked)]="question.PhotoRequired"
              (checkedChange)="questionChanged()"></app-toggle-switch>
            </div>
            <div class="flex mb-3 items-center md:justify-start justify-between">
              <div class="md:w-1/3">
                <p class=" text-green-400">Are Comments Allowed</p>
                <p class="text-sm text-grey-900 italic">Allows comments when answering</p>
              </div>
              <app-toggle-switch class="mt-1 ml-4" [(checked)]="question.AllowComments"
              (checkedChange)="questionChanged()"></app-toggle-switch>
            </div>
            <div class="flex mb-3 items-center md:justify-start justify-between">
              <div class="md:w-1/3">
                <p class="text-green-400">Is NA Valid</p>
                <p class="text-sm text-grey-900 italic">User can mark this as not applicable</p>
              </div>
              <app-toggle-switch class="mt-1 ml-4" [(checked)]="question.AllowNA"
              (checkedChange)="questionChanged()"></app-toggle-switch>
            </div>
            @if (isSelections) {
              <div class="flex mb-3 items-center md:justify-start justify-between">
                <div class="md:w-1/3">
                  <p class=" text-green-400">Exclude From Scores</p>
                  <p class="text-sm text-grey-900 italic">This will not impact scoring</p>
                </div>
                <app-toggle-switch class="mt-1 ml-4" [(checked)]="question.ExcludeScoreFromTotal"
                (checkedChange)="questionChanged()"></app-toggle-switch>
              </div>
            }
            <div class="flex mb-3 items-center md:justify-start justify-between">
              <div class="md:w-1/3">
                <p class=" text-green-400">Is Reference Question</p>
                <p class="text-sm text-grey-900 italic">Used to record information (like a name or other
                identifier) that will be shown with related answers, results, and actions.</p>
              </div>
              <app-toggle-switch class="mt-1 ml-4" [(checked)]="question.IsReference"
              (checkedChange)="questionChanged()"></app-toggle-switch>
            </div>
          </div>
        }
        @if (showScoring) {
          <div>
            <div>
              <h3>Question Limits</h3>
              <div class="mt-2">
                <p class="text-sm text-green-400">Compliance Limit</p>
                @if (question.QuestionType.ID == 1 || question.QuestionType.ID == 2) {
                  <p class="text-sm text-grey-900 italic"
                    >An answer must
                    score <strong>greater</strong> than this limit for the question to be compliant. If an
                  answer to the question is non-compliant an action will be raised.</p>
                }
                @if (question.QuestionType.ID == 3 ) {
                  <p class="text-sm text-grey-900 italic">The combined
                    score of selected answers must be <strong>greater</strong> than this limit or action
                  will be required.</p>
                }
                <input type="number" class="text-box md:w-1/5" placeholder="-1" [(ngModel)]="question.ComplianceLimit"
                  (ngModelChange)="questionChanged()" (change)="validateComplianceScore()" />
                  @if (false) {
                    <p class="text-danger-base text-sm mx-1">Please enter a valid number.</p>
                  }
                </div>
                <div class="mt-2">
                  <div class="flex items-center">
                    <p class="text-sm text-green-400">Max Score</p>
                    <p class="ml-1 underline  text-grey-900 hover:cursor-pointer"
                      (click)="toggleAdvancedScore()">@if (!question.AdvancedMaxScore) {
                      <span
                      class="text-xs">Advanced</span>
                      }@if (question.AdvancedMaxScore) {
                      <span class="text-xs"
                      >Basic</span>
                    }</p>
                  </div>
                  @if (!question.AdvancedMaxScore) {
                    <p class="text-lg ml-1">{{getMaxScore()}}</p>
                  }
                  @if (question.AdvancedMaxScore) {
                    <div>
                      <div class="flex items-center mt-1">
                        <span class="material-symbols-outlined text-lg text-grey-900">exclamation</span>
                        <p class="text-sm text-grey-900 italic">This will override the maximum score for the
                        question, total answer scores will be limited to this.</p>
                      </div>
                      <input type="number" class="text-box md:w-1/5" [(ngModel)]="question.MaxScore"
                        (ngModelChange)="questionChanged()" />
                        @if (false) {
                          <p class="text-danger-base text-sm mx-1">Please enter a valid number.</p>
                        }
                      </div>
                    }
                  </div>
                </div>
                  <div class="mt-2">
                  <div class="flex flex-col md:flex-row md:items-start md:justify-between gap-3 mb-2">
                    <div class="flex flex-col">
                      <h3 class="">Answers</h3>
                      <div class="flex  items-center group cursor-pointer" (click)="addAnswer()">
                        <span
                        class="material-symbols-outlined text-xl text-green-400 group-hover:text-green-700 cursor-pointer">add_circle</span>
                        <p class="text-green-400  group-hover:text-green-700 ml-1"> Add Answer</p>
                      </div>
                    </div>
                    <div class="w-full md:w-64">
                      @if (question.QuestionType.ID!=3 && question.QuestionAnswers.length>0) {
                        <div>
                          <p class="text-sm text-green-400">Default Answer</p>
                          <select class="text-box w-full" [ngModel]="currentDefaultAnswer()"
                            (ngModelChange)="changeDefaultSelection($event)">
                            <option [ngValue]="null">No Default</option>
                            @for(answer of question.QuestionAnswers; track answer) {
                              @if (answer.Active) {
                                <option [ngValue]="answer">{{answer.AnswerText}}</option>
                              }
                            }
                          </select>
                        </div>
                      }
                    </div>
                  </div>
                  @if (complianceScoringIssue) {
                    <div class="flex p-2 mb-2 w-full items-center">
                      <p class="text-warning-strong mr-1">The question cannot be compliant with the current
                        answers.
                      </p>
                      <span class="material-symbols-outlined text-warning-strong">nearby_error</span>
                    </div>
                  }
                  @if (question.QuestionAnswers.length>0) {
                    <div class="border-[1px] px-3 md:p-2 rounded-lg border-grey-900 min-h-10" cdkDropList
                      [cdkDropListData]="question.QuestionAnswers" (cdkDropListDropped)="drop($event)">
                      @for(a of question.QuestionAnswers;track a){
                        @if (a.Active) {
                          <div cdkDrag
                            class="flex flex-col md:flex-row justify-between mt-2 pb-2 border-b-[1px] items-center border-b-grey-500"
                            >
                            <div class="flex justify-start w-full md:w-auto mb-4 md:mb-0">
                              <div class=" md:w-4/5">
                                <p class="text-sm text-green-400">Name</p>
                                <input type="text" class="text-box" [(ngModel)]="a.AnswerText"    (ngModelChange)="questionChanged()"  />
                              </div>
                              <div class="pl-1 md:w-1/5">
                                <p class="text-sm text-green-400">Score</p>
                                <input type="number" class="text-box " (change)="validateComplianceScore()"
                                  (ngModelChange)="questionChanged()" [(ngModel)]="a.ComplianceScore" />
                                </div>
                              </div>
                              @if (question.QuestionType.ID == 1 || question.QuestionType.ID == 2) {
                                <div
                                  class="flex items-end md:ml-4 flex-grow">
                                  @if (a.ComplianceScore<=question.ComplianceLimit) {
                                    <p class="text-danger-base">
                                    Non-Compliant</p>
                                  }
                                  @if (a.ComplianceScore>question.ComplianceLimit) {
                                    <p class="text-green-400">
                                      Compliant @if (isMaxScore(a.ComplianceScore) && !question.ExcludeScoreFromTotal) {
                                      <span
                                      class="ml-1 text-grey-900">(Max Score)</span>
                                    }</p>
                                  }
                                </div>
                              }
                              <div class="flex justify-between w-full md:w-auto md:mt-0 mt-4">
                                <div class="flex flex-col md:flex-row mr-3 justify-between md:justify-center md:pt-0 pt-2 "
                                  >
                                  <app-simple-toggle [(isChecked)]="a.Actionable"
                                    (isCheckedChange)="questionChanged()"
                                  class="mr-1 self-center"></app-simple-toggle>
                                  <span class="text-sm ">action required</span>
                                </div>
                                <div class="flex flex-col md:flex-row text-sm group cursor-pointer mr-3 items-center "
                                  (click)="removeAnswer(a)"><span
                                class=" material-symbols-outlined text-2xl  group-hover:text-danger-base items-center md:mr-1">delete</span><span
                              class="text-sm text-danger-base md:self-start">delete</span></div>
                              <span cdkDragHandle
                              class="material-symbols-outlined cursor-move self-end md:self-auto">drag_indicator</span>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <div class="flex w-full flex-col md:flex-row  mt-6 justify-between" >
              <button class="btn-primary flex justify-between items-center"
                (click)="confirmChanges()"><span>Confirm</span><span
              class="ml-2 material-symbols-outlined">check</span></button>
              <button class="flex justify-between items-center mt-2 md:mt-0"
                [ngClass]="question.InitialQuestion ? 'btn-danger' : 'btn-inverse'"
                (click)="undoChanges()">@if (!question.InitialQuestion) {
                <span>Cancel</span>
                }@if (question.InitialQuestion) {
                <span>Remove</span>
                }<span
              class="ml-2 material-symbols-outlined">undo</span></button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
